import React from "react";
import { motion } from "framer-motion";

const EqualOpportunity = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    return (
        <section className="w-full text-left relative z-10 overflow-hidden">
            <div className="max-w-[1280px] mx-auto w-full bg-[#F1F1F1] border border-[#E4E8F5] flex flex-col lg:flex-row items-stretch min-h-auto lg:min-h-[420px]">

                <motion.div
                    navigator
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="w-full lg:max-w-[709px] p-6 sm:p-10 md:p-12 lg:p-14 flex flex-col justify-between h-auto min-h-full order-2 lg:order-1"
                >
                    <motion.h2
                        variants={fadeUpVariants}
                        className="text-[20px] md:text-[30px] font-[600] max-w-[400px] text-[#01386A] font-sora leading-tight md:leading-[1.5] tracking-tight break-words w-full mb-6 lg:mb-0"
                    >
                        We are an Equal Opportunity Employer
                    </motion.h2>

                    <div className="w-full flex flex-col max-w-[572px] gap-4 sm:gap-5 mt-auto">
                        <motion.p
                            variants={fadeUpVariants}
                            className="text-[14px] md:text-[16px] text-[#49577A] font-graphik font-[500] leading-relaxed break-words w-full"
                        >
                            Cybage believes in 'being just,' and provides equal opportunities for its employees to thrive in diverse roles and responsibilities.
                        </motion.p>
                        <motion.p
                            variants={fadeUpVariants}
                            className="text-[14px] md:text-[16px] text-[#49577A] font-graphik font-[500] leading-relaxed break-words w-full"
                        >
                            Across the board, we take an unbiased approach to work and do not discriminate on the basis of age, race, religion, sex, gender, ethnicity, sexual orientation, or disability.
                        </motion.p>
                    </div>
                </motion.div>

                <div className="w-full lg:max-w-[571px] relative min-h-[260px] sm:min-h-[320px] lg:min-h-full overflow-hidden bg-slate-900 shrink-0 group order-1 lg:order-2 aspect-[4/3] sm:aspect-[16/10] lg:aspect-auto">
                    <motion.img
                        whileHover={{ scale: 1.04 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        src="/assets/diversity/img9.png"
                        alt="Giant ferris wheel with blue glowing LED neon lights at dusk night sky"
                        className="w-full h-full object-cover absolute inset-0 transition-transform duration-500"
                    />
                </div>

            </div>
        </section>
    );
};

export default EqualOpportunity;